import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const INDEXING_ENABLED = true;

const SITE = {
  name: {
    en: "LANDKING Saudi Arabia",
    ar: "لاند كينج السعودية"
  },
  domain: "https://www.landkingksa.com",
  ogImage: "https://www.landkingksa.com/og-image.jpg",
  twitterCard: "summary_large_image",
  locales: {
    en: "en_SA",
    ar: "ar_SA"
  }
};

const SEO_MAP = {
  "/": {
    en: {
      title: "LANDKING - BTATC | Light Commercial Vehicles in Saudi Arabia",
      description:
        "Official LANDKING distributor in Saudi Arabia. Light commercial vehicles for delivery, cargo and fleet operations, with genuine parts and professional aftersales support.",
      keywords:
        "LANDKING Saudi Arabia, Landking KSA, light commercial vehicles Saudi Arabia, commercial vehicles Saudi Arabia, fleet vehicles Saudi Arabia, cargo vehicles Saudi Arabia, BTATC, delivery vehicles Saudi Arabia"
    },
    ar: {
      title: "لاند كينج السعودية | المركبات التجارية الخفيفة في المملكة العربية السعودية",
      description:
        "الموزع الرسمي لمركبات لاند كينج في المملكة العربية السعودية. مركبات تجارية خفيفة لأعمال التوصيل، نقل البضائع وتشغيل الأساطيل، مع قطع غيار أصلية ودعم ما بعد البيع الاحترافي.",
      keywords:
        "لاند كينج السعودية, مركبات لاند كينج, المركبات التجارية الخفيفة, سيارات نقل خفيفة, مركبات توصيل, مركبات شحن, أسطول تجاري, BTATC"
    }
  },
  "/vehicles": {
    en: {
      title: "Vehicles | LANDKING Light Commercial Vehicles Saudi Arabia",
      description:
        "Explore LANDKING light commercial vehicles in Saudi Arabia. Efficient and reliable LCV models for urban transport, cargo delivery and business fleets.",
      keywords:
        "LANDKING vehicles Saudi Arabia, light commercial vehicles Saudi Arabia, LCV Saudi Arabia, delivery vans Saudi Arabia, cargo vehicles Saudi Arabia, business fleet vehicles"
    },
    ar: {
      title: "المركبات | لاند كينج للمركبات التجارية الخفيفة في السعودية",
      description:
        "استكشف مركبات لاند كينج التجارية الخفيفة في المملكة العربية السعودية. موديلات عملية وموثوقة للنقل داخل المدن، توصيل البضائع وتشغيل أساطيل الأعمال.",
      keywords:
        "مركبات لاند كينج, مركبات تجارية خفيفة السعودية, سيارات نقل تجاري, سيارات توصيل, مركبات شحن خفيفة, أسطول أعمال"
    }
  },
  "/vehicles/h-series": {
    en: {
      title: "H-Series | LANDKING Light Commercial Vehicles Saudi Arabia",
      description:
        "Discover the LANDKING H-Series light commercial vehicles in Saudi Arabia, designed for delivery operations and daily business transport needs.",
      keywords:
        "LANDKING H-Series Saudi Arabia, H-Series truck Saudi Arabia, light duty truck Saudi Arabia, delivery truck Saudi Arabia, commercial truck Saudi Arabia"
    },
    ar: {
      title: "سلسلة H | لاند كينج للمركبات التجارية الخفيفة في السعودية",
      description:
        "اكتشف مركبات لاند كينج سلسلة H في المملكة العربية السعودية، المصممة لعمليات التوصيل واحتياجات النقل التجاري اليومي بكفاءة واعتمادية.",
      keywords:
        "سلسلة H لاند كينج, شاحنة لاند كينج, شاحنة خفيفة السعودية, مركبة توصيل تجارية, شاحنة أعمال"
    }
  },
  "/spare-parts": {
    en: {
      title: "Spare Parts | Genuine LANDKING LCV Parts Saudi Arabia",
      description:
        "Genuine spare parts for LANDKING light commercial vehicles in Saudi Arabia. Ensure performance, reliability and long-term durability.",
      keywords:
        "LANDKING spare parts Saudi Arabia, genuine commercial vehicle parts, light commercial vehicle parts Saudi Arabia, LANDKING parts KSA"
    },
    ar: {
      title: "قطع الغيار | قطع لاند كينج الأصلية في السعودية",
      description:
        "قطع غيار أصلية لمركبات لاند كينج التجارية الخفيفة في المملكة العربية السعودية، للحفاظ على الأداء والاعتمادية والمتانة على المدى الطويل.",
      keywords:
        "قطع غيار لاند كينج, قطع غيار أصلية, قطع مركبات تجارية, قطع سيارات نقل, لاند كينج السعودية"
    }
  },
  "/services": {
    en: {
      title: "Services | LANDKING LCV Maintenance Saudi Arabia",
      description:
        "Professional maintenance and aftersales services for LANDKING light commercial vehicles across Saudi Arabia, including repairs and warranty support.",
      keywords:
        "LANDKING services Saudi Arabia, LANDKING maintenance, commercial vehicle service Saudi Arabia, aftersales support, warranty support"
    },
    ar: {
      title: "الخدمات | صيانة لاند كينج للمركبات التجارية الخفيفة في السعودية",
      description:
        "خدمات صيانة احترافية ودعم ما بعد البيع لمركبات لاند كينج التجارية الخفيفة في مختلف مناطق المملكة العربية السعودية، بما يشمل الإصلاحات ودعم الضمان.",
      keywords:
        "خدمات لاند كينج, صيانة لاند كينج, صيانة مركبات تجارية, خدمات ما بعد البيع, دعم الضمان السعودية"
    }
  },
  "/about-us": {
    en: {
      title: "About LANDKING Saudi Arabia | Official Distributor",
      description:
        "BTATC is the official LANDKING distributor in Saudi Arabia, delivering light commercial vehicles with nationwide parts and service support.",
      keywords:
        "about LANDKING Saudi Arabia, official LANDKING distributor, BTATC Saudi Arabia, LANDKING dealer Saudi Arabia"
    },
    ar: {
      title: "عن لاند كينج السعودية | الموزع الرسمي",
      description:
        "تعد BTATC الموزع الرسمي لمركبات لاند كينج في المملكة العربية السعودية، مع توفير دعم شامل لقطع الغيار والخدمات على مستوى المملكة.",
      keywords:
        "عن لاند كينج, الموزع الرسمي لاند كينج, BTATC, وكيل لاند كينج السعودية"
    }
  },
  "/locations": {
    en: {
      title: "Locations | LANDKING Showrooms Saudi Arabia",
      description:
        "Find LANDKING showrooms and service centers in Saudi Arabia for vehicle sales, spare parts and aftersales assistance.",
      keywords:
        "LANDKING locations Saudi Arabia, LANDKING showroom, service center Saudi Arabia, dealer locations Saudi Arabia"
    },
    ar: {
      title: "المواقع | معارض ومراكز خدمة لاند كينج في السعودية",
      description:
        "اعثر على معارض ومراكز خدمة لاند كينج في المملكة العربية السعودية لمبيعات المركبات، قطع الغيار وخدمات ما بعد البيع.",
      keywords:
        "مواقع لاند كينج, معارض لاند كينج, مراكز خدمة لاند كينج, وكيل لاند كينج السعودية"
    }
  },
  "/faq": {
    en: {
      title: "FAQ | LANDKING Saudi Arabia LCV Support",
      description:
        "Frequently asked questions about LANDKING light commercial vehicles in Saudi Arabia, including warranty, spare parts and maintenance services.",
      keywords:
        "LANDKING FAQ, LANDKING support Saudi Arabia, warranty questions, spare parts questions, maintenance questions"
    },
    ar: {
      title: "الأسئلة الشائعة | دعم لاند كينج السعودية",
      description:
        "الأسئلة الشائعة حول مركبات لاند كينج التجارية الخفيفة في المملكة العربية السعودية، بما يشمل الضمان، قطع الغيار وخدمات الصيانة.",
      keywords:
        "الأسئلة الشائعة لاند كينج, دعم لاند كينج, ضمان لاند كينج, قطع غيار لاند كينج, صيانة لاند كينج"
    }
  },
  "/landking-showroom-riyadh-opening-btatc": {
    en: {
      title: "LANDKING Showroom Opens in Riyadh | BTATC Launches H-Series and EH Electric Trucks",
      description:
        "BTATC officially opened the LANDKING showroom in Riyadh on 10 December 2025, featuring the H-Series launch, EH electric truck reveal, leadership speeches, and a new destination for Saudi commercial vehicle buyers.",
      keywords:
        "LANDKING showroom Riyadh, BTATC Riyadh showroom, LANDKING Saudi Arabia, LANDKING H-Series Saudi Arabia, EH electric truck Saudi Arabia, commercial truck showroom Riyadh, truck launch Riyadh, light commercial vehicles Saudi Arabia"
    },
    ar: {
      title: "افتتاح معرض لاند كينج في الرياض | BTATC تدشن شاحنات H-Series وEH الكهربائية",
      description:
        "افتتحت BTATC رسميًا معرض لاند كينج في الرياض بتاريخ 10 ديسمبر 2025، مع تدشين شاحنات H-Series والكشف عن EH الكهربائية، في خطوة تعزز حضور لاند كينج في سوق المركبات التجارية بالمملكة.",
      keywords:
        "افتتاح معرض لاند كينج الرياض, BTATC الرياض, لاند كينج السعودية, شاحنات H-Series السعودية, شاحنة كهربائية EH السعودية, معرض شاحنات الرياض, المركبات التجارية السعودية"
    }
  },
  "/privacy-policy": {
    en: {
      title: "Privacy Policy | LANDKING Saudi Arabia",
      description:
        "Learn how LANDKING Saudi Arabia collects, uses and protects information when you visit our website or contact us.",
      keywords:
        "privacy policy LANDKING Saudi Arabia, LANDKING data protection, privacy notice"
    },
    ar: {
      title: "سياسة الخصوصية | لاند كينج السعودية",
      description:
        "تعرف على كيفية قيام لاند كينج السعودية بجمع المعلومات واستخدامها وحمايتها عند زيارة موقعنا الإلكتروني أو التواصل معنا.",
      keywords:
        "سياسة الخصوصية لاند كينج, حماية البيانات, الخصوصية السعودية"
    }
  },
  "/terms-conditions": {
    en: {
      title: "Terms & Conditions | LANDKING Saudi Arabia",
      description:
        "Terms and conditions governing the use of the LANDKING Saudi Arabia website, products and services.",
      keywords:
        "LANDKING terms and conditions, website terms Saudi Arabia, LANDKING legal"
    },
    ar: {
      title: "الشروط والأحكام | لاند كينج السعودية",
      description:
        "الشروط والأحكام التي تنظم استخدام موقع لاند كينج السعودية الإلكتروني ومنتجاته وخدماته.",
      keywords:
        "الشروط والأحكام لاند كينج, شروط الاستخدام, لاند كينج السعودية"
    }
  }
};

function normalizeLang(rawLang) {
  if (!rawLang) return "en";
  return rawLang.toLowerCase().startsWith("ar") ? "ar" : "en";
}

function upsertMeta(name, content) {
  if (!content) return;
  let tag = document.querySelector(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("name", name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

function upsertProperty(property, content) {
  if (!content) return;
  let tag = document.querySelector(`meta[property="${property}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("property", property);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

function upsertLink(rel, href, hreflang) {
  let selector = `link[rel="${rel}"]`;
  if (hreflang) selector += `[hreflang="${hreflang}"]`;

  let link = document.querySelector(selector);
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", rel);
    if (hreflang) link.setAttribute("hreflang", hreflang);
    document.head.appendChild(link);
  }
  link.setAttribute("href", href);
}

function upsertJsonLd(id, data) {
  let tag = document.querySelector(`script[data-schema-id="${id}"]`);
  if (!tag) {
    tag = document.createElement("script");
    tag.type = "application/ld+json";
    tag.setAttribute("data-schema-id", id);
    document.head.appendChild(tag);
  }
  tag.textContent = JSON.stringify(data);
}

export default function MetaManager() {
  const { pathname } = useLocation();
  const { i18n } = useTranslation();
  const lang = normalizeLang(i18n?.resolvedLanguage || i18n?.language || document.documentElement.lang);

  useEffect(() => {
    const routeData = SEO_MAP[pathname] || SEO_MAP["/"];
    const data = routeData[lang] || routeData.en;
    const canonical = SITE.domain + (pathname === "/" ? "" : pathname);
    const siteName = SITE.name[lang] || SITE.name.en;
    const locale = SITE.locales[lang] || SITE.locales.en;

    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";

    if (pathname === "/vehicles/h-series") {
      const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        name: lang === "ar" ? "لاند كينج سلسلة H" : "LANDKING H-Series",
        image: [SITE.ogImage],
        description:
          lang === "ar"
            ? "مركبات لاند كينج سلسلة H التجارية الخفيفة المصممة للتوصيل، نقل البضائع وتشغيل الأساطيل في المملكة العربية السعودية."
            : "LANDKING H-Series light commercial vehicles designed for delivery, cargo transport, and fleet operations in Saudi Arabia.",
        brand: {
          "@type": "Brand",
          name: "LANDKING"
        },
        manufacturer: {
          "@type": "Organization",
          name: "LANDKING"
        },
        category: lang === "ar" ? "مركبة تجارية خفيفة" : "Light Commercial Vehicle",
        url: canonical,
        offers: {
          "@type": "Offer",
          url: canonical,
          priceCurrency: "SAR",
          availability: "https://schema.org/InStock",
          itemCondition: "https://schema.org/NewCondition",
          seller: {
            "@type": "Organization",
            name: siteName
          }
        }
      };

      upsertJsonLd("product-h-series", productSchema);
    }

    if (pathname === "/landking-showroom-riyadh-opening-btatc") {
      const articleSchema = {
        "@context": "https://schema.org",
        "@type": "Article",
        headline:
          lang === "ar"
            ? "افتتاح معرض لاند كينج في الرياض | BTATC تدشن شاحنات H-Series وEH الكهربائية"
            : "LANDKING Showroom Opens in Riyadh | BTATC Launches H-Series and EH Electric Trucks",
        description: data.description,
        image: [
          `${SITE.domain}/images/blog/landking-showroom-riyadh-opening.jpg`,
          `${SITE.domain}/images/blog/landking-h-series-riyadh-launch.jpg`,
          `${SITE.domain}/images/blog/landking-eh-series-electric-truck-saudi-arabia.jpg`
        ],
        mainEntityOfPage: canonical,
        url: canonical,
        inLanguage: lang === "ar" ? "ar-SA" : "en-SA",
        datePublished: "2025-12-10",
        dateModified: "2025-12-10",
        author: {
          "@type": "Organization",
          name: "BTATC"
        },
        publisher: {
          "@type": "Organization",
          name: siteName,
          logo: {
            "@type": "ImageObject",
            url: `${SITE.domain}/logo.png`
          }
        },
        about: [
          lang === "ar" ? "لاند كينج السعودية" : "LANDKING Saudi Arabia",
          "BTATC",
          "Riyadh showroom",
          "H-Series",
          "EH Series"
        ]
      };

      upsertJsonLd("article-landking-riyadh-opening", articleSchema);
    }

    document.title = data.title;
    upsertMeta("description", data.description);
    upsertMeta("keywords", data.keywords);
    upsertMeta("robots", INDEXING_ENABLED ? "index, follow" : "noindex, follow");
    upsertMeta("language", lang === "ar" ? "Arabic" : "English");

    upsertLink("canonical", canonical);

    upsertProperty("og:type", pathname === "/landking-showroom-riyadh-opening-btatc" ? "article" : "website");
    upsertProperty("og:site_name", siteName);
    upsertProperty("og:locale", locale);
    upsertProperty("og:url", canonical);
    upsertProperty("og:title", data.title);
    upsertProperty("og:description", data.description);
    upsertProperty(
      "og:image",
      pathname === "/landking-showroom-riyadh-opening-btatc"
        ? `${SITE.domain}/images/blog/landking-showroom-riyadh-opening.jpg`
        : SITE.ogImage
    );

    upsertMeta("twitter:card", SITE.twitterCard);
    upsertMeta("twitter:title", data.title);
    upsertMeta("twitter:description", data.description);
    upsertMeta(
      "twitter:image",
      pathname === "/landking-showroom-riyadh-opening-btatc"
        ? `${SITE.domain}/images/blog/landking-showroom-riyadh-opening.jpg`
        : SITE.ogImage
    );

    // Note: These point to the same URL because the current site uses language switching
    // without dedicated language-specific URLs. For full multilingual SEO, use separate URLs.
    upsertLink("alternate", canonical, "en-SA");
    upsertLink("alternate", canonical, "ar-SA");
    upsertLink("alternate", canonical, "x-default");
  }, [pathname, lang]);

  return null;
}
